module.exports = __webpack_public_path__ + "odinstatic/media/operations.54e0d4ac.svg";